import { ProfileScrapRoute } from './ProfileScrapRoute';
import { MyDispatchPage } from '../pages/executive/warehouse/MyDispatchPage';
import { DispatchShift } from '../pages/dashboard/roles/DispatchShift';
import { QualityDashboard } from '../pages/dashboard/roles/QualityDashboard';
import { InspectorDashboard } from '../pages/dashboard/roles/InspectorDashboard';
import { QualityWorkflowRoute, InspectorWorkflowRoute, QualityIncomingRoute, QualityFloorRoute } from './ProfileQualityRoutes';
import { ProfileRejectionsRoute } from './ProfileRejectionsRoute';
import { ProfileQcHandoffRoute } from './ProfileQcHandoffRoute';
import { ProfileShiftControlRoute } from './ProfileShiftControlRoute';
import { ProfileProductionRoute } from './ProfileProductionRoute';
import { ProfileShortagesRoute } from './ProfileShortagesRoute';
import { ProductionOperatorDashboard } from '../pages/dashboard/executive/ProductionOperatorDashboard';
import { BuyerLandedCostRoute } from './BuyerLandedCostRoute';
import { ProfilePurchaseOrdersRoute } from './ProfilePurchaseOrdersRoute';
import { ProfileInventoryRoute } from './ProfileInventoryRoute';
import { RawMaterialsPage } from '../pages/warehouse/RawMaterialsPanel';
import { Route, Navigate } from 'react-router-dom';
import * as Pages from './routePages';
import { DEALER_PAGE_ROLES } from '../lib/roles';
import { RequireRoles, RequireCapability, BlockReps, StrictViewBlock, RoleAwareHome, RoleAwareDashboard } from './routingGuards';
import { NoAccessPage } from '../components/auth/ProfileRouteGuard';
export function operationsRoutes() {
  return <>
<Route path="/warehouse/putaway" element={<Pages.StockTransfersPage workflow="putaway"/>}/>
<Route path="/warehouse/issue" element={<Pages.StockTransfersPage workflow="issue"/>}/>

{['/gate','/gate/queue','/gate/scan-in','/gate/scan-out','/gate/log'].map(path => <Route key={path} path={path} element={<Pages.GatePassRegisterPage gateWork/>}/>)}
{/* 2026-10-04 Gate Entry — Material IN (GST evidence record) */}
<Route path="/gate/entry" element={<Pages.GateEntryStationPage/>}/>
<Route path="/warehouse/gate-entries" element={<Pages.GateEntryRegisterPage/>}/>

{['/loading','/loads','/loading/scan','/loading/photos','/loading/damage'].map(path => <Route key={path} path={path} element={<MyDispatchPage/>}/>)}
<Route path="/dispatch/shortages" element={<Pages.DispatchFormsPage mode="shortages"/>}/>
<Route path="/dispatch/account-status" element={<Pages.DispatchFormsPage mode="accounts"/>}/>
<Route path="/dispatch/loading" element={<DispatchShift loadingOnly/>}/>

<Route path="/quality" element={<QualityDashboard/>}/>
<Route path="/quality/disposition" element={<QualityWorkflowRoute view="disposition"/>}/>
<Route path="/quality/release" element={<QualityWorkflowRoute view="release"/>}/>
<Route path="/quality/count-approvals" element={<QualityWorkflowRoute view="counts"/>}/>
<Route path="/quality/escalations" element={<QualityWorkflowRoute view="escalations"/>}/>
<Route path="/inspect" element={<InspectorDashboard/>}/>
{(['queue','readings','scan','escalations'] as const).map(mode=><Route key={mode} path={`/inspect/${mode}`} element={<InspectorWorkflowRoute mode={mode}/>}/>)}
<Route path="/dispatch-status" element={<Pages.DispatchFormsPage readOnly />} />
<Route path="/warehouse/dashboard" element={<Pages.InventoryDashboardPage />} />
<Route path="/warehouse/inward" element={<Pages.InwardDashboardPage />} />
<Route path="/warehouse/grn" element={<Pages.InwardDashboardPage />} />
<Route path="/job-work" element={<Pages.JobWorkChallansPage />} />
<Route path="/job-work/ledger" element={<Pages.JobWorkLedgerPage />} />
<Route path="/warehouse/dispatch-dashboard" element={<Pages.DispatchDashboardPage />} />
<Route path="/products" element={<Pages.ProductsPage />} />
<Route path="/product-catalogue" element={<Pages.ProductCataloguePage />} />
<Route path="/product-settings" element={<Pages.ProductSettingsPage />} />
<Route path="/inventory" element={<ProfileInventoryRoute />} />
      <Route path="/raw-materials" element={<RawMaterialsPage />} />
<Route path="/warehouse/inventory-pipeline" element={<Pages.InventoryPipelinePage />} />
<Route path="/production" element={<ProfileProductionRoute />} />
<Route path="/warehouse/stock-audit" element={<Pages.StockAuditPage />} />
<Route path="/warehouse/transfers" element={<Pages.StockTransfersPage />} />
<Route path="/warehouse/barcode-print" element={<Pages.BatchBarcodePrintPage />} />
<Route path="/warehouse/dispatch-register" element={<Pages.DailyDispatchRegisterPage />} />
<Route path="/warehouse/receiving-register" element={<Pages.DailyReceivingRegisterPage />} />
<Route path="/warehouse/gate-passes" element={<Pages.GatePassRegisterPage />} />
<Route path="/warehouse/barcode-onboarding" element={<Pages.BarcodeOnboardingPage />} />
<Route path="/customer-returns" element={<Pages.CustomerReturnsPage />} />
<Route path="/returns" element={<Pages.ReturnDashboardPage />} />
<Route path="/manufacturing/packing/ss-tank/:id" element={<Pages.SsTankPackingPage />} />
<Route path="/manufacturing/packing/solar-wh/:id" element={<Pages.SolarWhPackingPage />} />
<Route path="/manufacturing/packing/heat-pump/:id" element={<Pages.HeatPumpPackingPage />} />
<Route path="/warehouse-locations" element={<Pages.WarehouseLocationsPage />} />
<Route path="/purchase-dashboard" element={<Pages.PurchaseDashboardPage />} />
<Route path="/vendor-rate-comparison" element={<Pages.VendorRateComparisonPage />} />
<Route path="/vendor-returns" element={<Pages.VendorReturnsPage />} />
<Route path="/vendor-returns/:id" element={<Pages.VendorReturnDetailPage />} />
<Route path="/purchase-requests" element={<Pages.PurchaseRequestsPage />} />
<Route path="/purchase-requests/:id" element={<Pages.PurchaseRequestDetailPage />} />
<Route path="/vendors" element={<Pages.VendorsPage />} />
<Route path="/purchase-orders" element={<ProfilePurchaseOrdersRoute />} />
<Route path="/purchase-orders/new" element={<Pages.PurchaseOrderEditorPage />} />
<Route path="/purchase-orders/:id/edit" element={<Pages.PurchaseOrderEditorPage />} />
<Route path="/procurement/landed-cost" element={<BuyerLandedCostRoute />} />
<Route path="/quotation-jobs" element={<Pages.QuotationJobsPage />} />
<Route path="/quotation-jobs/:id" element={<Pages.QuotationJobDetailPage />} />
<Route path="/transport-partners" element={<Pages.TransportPartnersPage />} />
<Route path="/shipments" element={<Pages.ShipmentsPage />} />
<Route path="/dispatch" element={<Pages.DispatchMobileFallbackPage />} />
<Route path="/shipments/:id" element={<Pages.ShipmentDetailPage />} />
<Route path="/logistics/rate-comparison" element={<Pages.LogisticsRateComparisonPage />} />
<Route path="/logistics/flow" element={<Pages.LogisticsFlowPage />} />
<Route path="/logistics/pipeline" element={<Pages.DeliveryPipelinePage />} />
<Route path="/logistics/tracker" element={<Pages.PostDispatchTrackerPage />} />
<Route path="/logistics/templates" element={<Pages.WaTemplateHealthPage />} />
<Route path="/dispatch-config" element={<Pages.DispatchConfigPage />} />
<Route path="/dispatch-config/from-so/:salesOrderId" element={<Pages.SODispatchCreatorPage />} />
<Route path="/dispatch-forms/new/:salesOrderId" element={<Pages.SODispatchCreatorPage />} />
<Route path="/dispatch-forms" element={<Pages.DispatchFormsPage />} />
<Route path="/dispatch-forms/:id" element={<Pages.DispatchFormDetailPage />} />
<Route path="/dispatch-config/slip/:id" element={<Navigate to="/dispatch-forms" replace />} />
<Route path="/warehouse/cash-rewards" element={<Pages.CashRewardStickersPage />} />
<Route path="/purchase-contracts" element={<Pages.PurchaseContractsPage />} />
<Route path="/transport-contracts" element={<Pages.TransportContractsPage />} />
<Route path="/manufacturing/boms" element={<Pages.BOMsPage />} />
<Route path="/boms/new" element={<Pages.BOMEditorPage />} />
<Route path="/boms/:id/edit" element={<Pages.BOMEditorPage />} />
<Route path="/manufacturing/orders/new" element={<Pages.ProductionOrderCreatePage />} />
<Route path="/production-orders/:id" element={<Pages.ProductionOrderDetailPage />} />
<Route path="/manufacturing/orders/:id" element={<Pages.ProductionOrderDetailPage />} />
<Route path="/manufacturing/production-orders/:id" element={<Pages.ProductionOrderDetailPage />} />
<Route path="/qc-templates" element={<Pages.QCTemplatesPage />} />
<Route path="/manufacturing/instruments" element={<Pages.InstrumentsPage />} />
<Route path="/rejections" element={<ProfileRejectionsRoute />} />
{['/my-shift','/my-shift/tasks','/my-shift/machine-check','/my-shift/readings','/my-shift/checklist','/my-shift/photos','/my-shift/move','/my-shift/problem'].map(path=><Route key={path} path={path} element={<ProductionOperatorDashboard/>}/>)}
<Route path="/manufacturing/shortages" element={<ProfileShortagesRoute/>}/>
<Route path="/manufacturing/dashboard" element={<Pages.ProductionDashboardV3 />} />
<Route path="/manufacturing/shop-floor" element={<Navigate to="/manufacturing/dashboard" replace />} />
<Route path="/manufacturing/planning" element={<Pages.ProductionPlanningPage />} />
<Route path="/production/plan" element={<Pages.BucketedProductionPlanPage />} />
<Route path="/production-planning" element={<Pages.BucketedProductionPlanPage />} />
<Route path="/manufacturing/shift-control" element={<ProfileShiftControlRoute />} />
<Route path="/manufacturing/rm-inspection" element={<QualityIncomingRoute />} />
<Route path="/manufacturing/process-kanban" element={<Pages.ProcessKanbanPage />} />
<Route path="/manufacturing/qc" element={<ProfileQcHandoffRoute />} />
<Route path="/manufacturing/lot-approvals" element={<Pages.LotApprovalsPage />} />
{/* 2026-10-04 SR hand-off — serial numbering */}
<Route path="/serials/numbering" element={<Pages.SerialNumberingPage />} />
<Route path="/serials/seeding" element={<Pages.CounterSeedingPage />} />
<Route path="/serials/labels" element={<Pages.LabelBatchesPage />} />
<Route path="/serials/frame-station" element={<Pages.FrameStationPage />} />
<Route path="/serials/po-ranges" element={<Pages.PoSerialRangesPage />} />
<Route path="/serials/boxes" element={<Pages.TubeBoxesPage />} />
<Route path="/manufacturing/dispatch" element={<Pages.ManufacturingDispatchPage />} />
<Route path="/manufacturing/alerts" element={<Pages.ManufacturingAlertsPage />} />
<Route path="/manufacturing/pipeline" element={<Pages.ProductionPipelinePage />} />
<Route path="/manufacturing/shift-report" element={<Pages.EndOfShiftReportPage />} />
<Route path="/manufacturing/barcodes" element={<Pages.BarcodeManagementPage />} />
<Route path="/manufacturing/scrap" element={<ProfileScrapRoute />} />
<Route path="/manufacturing/pipeline-config" element={<Navigate to="/manufacturing/process-kanban" replace />} />
<Route path="/manufacturing/floor-inspection" element={<QualityFloorRoute />} />
<Route path="/warehouse/barcode-lifecycle" element={<Pages.BarcodeLifecyclePage />} />
<Route path="/warehouse/product-units" element={<Pages.ProductUnitsPage />} />
<Route path="/so-po-mapping" element={<Pages.SoPoMappingPage />} />
<Route path="/inventory/units/:code/history" element={<Pages.ProductUnitWarrantyHistoryPage />} />
<Route path="/products/:id/docs" element={<Pages.ProductDocsAdminPage />} />
<Route path="/warehouse" element={<Navigate to="/warehouse/dashboard" replace />} />
<Route path="/warehouse/inventory" element={<Navigate to="/inventory" replace />} />
<Route path="/dispatch/shipments" element={<Pages.ShipmentsPage />} />
<Route path="/dispatch/shipments/:id" element={<Pages.ShipmentDetailPage />} />
  </>;
}
